import { Outlet } from "react-router";

import Navbar from './components/navbar/navbar';
import headerLogo from 'url:./images/headerLogo.png';

import './header.css';

export default function Header(){
	return <header>
		<img src={headerLogo} id='headerLogo' alt="" />

		<div className='blockBarContainer'>
			<div className='blockBar'></div>
		</div>

		<Navbar />
		<Outlet />
	</header>
}